import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Specializations.css'

function CriminalLaw() {

  useEffect(() => {
    document.title = "Criminal Law - Legal Trails";  // Set Page Title
  }, []);

  return (
    <>
    <Navbar />
    <div className="law">
      
      <section className="specializations-detail">
        <div className="container">
          <div className="header-image">
            <img 
              src="/criminal.jpg" 
              alt="Criminal Law" 
              loading="lazy" 
              onLoad={(e) => e.target.style.opacity = 1}
              style={{ opacity: 0, transition: "opacity 0.3s ease-in-out" }} 
            />
          </div>
          <div className="content">
            <p>
            At Legal Trails, we are dedicated to delivering effective legal solutions and advocacy in all areas of criminal law, ensuring clients receive exceptional support and representation. With extensive experience handling diverse criminal matters across India, our team has successfully managed cases for both individuals and corporate clients, including the freezing of bank accounts and attachment of property. We handle offences affecting the human body, such as murder, suicide, dowry death, causing death by negligence, rape, and kidnapping, as well as property offences like theft, robbery, extortion, cheating, breach of trust, and misappropriation of properties. Additionally, we specialize in financial offences, including criminal misappropriation of funds, breach of trust, conspiracy, and dishonor of cheques under the Negotiable Instruments Act.</p>

            <div className="button-container">
              <Link to="/contact">
                <button className="contact-button">Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer />
    </>
  );
}

export default CriminalLaw;